import {
  RM_TICKET,
  RM_TICKET_REPORT,
  RM_TICKET_DETAILS,
  RM_STATUS,
  RM_TICKET_FILTER,
  GET_MATERIAL,
  GET_EQUIPMENT,
  RM_TICKET_DETAILS_FOR_UPDATION,
  RM_TICKET_DETAILS_SLOT
} from "./type";

const initalState = {
  rmTicket: {},
  rmTicketReport:{},
  rmTicketDetails: {},
  rmStatus: [],
  materials: [],
  rmTicketFilter: {},
  equipments: [],
  rmTicketDetailsForUpdation: {},
  rmTicketDetailsForSlot: {},
};

const rmTicketReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RM_TICKET:
      return {
        ...state,
        rmTicket: payload,
      };
    case RM_TICKET_REPORT:
    return {
      ...state,
      rmTicketReport: payload,
    };
    case RM_TICKET_DETAILS:
      return {
        ...state,
        rmTicketDetails: payload,
      };
    case RM_STATUS:
      return {
        ...state,
        rmStatus: payload,
      };
    case GET_MATERIAL:
    return {
      ...state,
      materials: payload,
    };
    case RM_TICKET_FILTER:
      return {
        ...state,
        rmTicketFilter: payload,
      };
    case GET_EQUIPMENT:
      return {
        ...state,
        equipments: payload,
      };
    case RM_TICKET_DETAILS_FOR_UPDATION:
      return {
        ...state,
        rmTicketDetailsForUpdation: payload,
      };
    case RM_TICKET_DETAILS_SLOT:
      return {
        ...state,
        rmTicketDetailsForSlot: payload,
      };  
    default:
      return {
        ...state,
      };
  }
};

export default rmTicketReducer;
